<div class="container d-flex justify-content-center align-items-center">
  <img src="../../../assets/images/cargando.gif" alt="Loading">
</div>
